// Abre o modal de nova tarefa da barra superior a partir de qualquer tela (ex.: item do checklist).
// O `Navbar` escuta este evento, que só existe para quem pode criar tarefa (não o usuário externo).
export const OPEN_NEW_TASK_EVENT = 'taskrush:open-new-task'

export const openNewTask = () => {
  window.dispatchEvent(new Event(OPEN_NEW_TASK_EVENT))
}
